import { render, staticRenderFns } from "./VeChainStatsLink.vue?vue&type=template&id=16d900db"
import script from "./VeChainStatsLink.vue?vue&type=script&lang=ts"
export * from "./VeChainStatsLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports